import { AccountInformationsARApiProps } from 'services/account-info/types'

import { interWbSession } from '@interco/inter-webview-bridge'

import { data as languageData } from '../data'

export const handleShareClick = (
  normalizedLanguage: string,
  item?: AccountInformationsARApiProps,
  title?: string,
) => {
  const message = item
    ? Object.entries(item)
        .filter(([key, value]) => !['description', 'type', 'title'].includes(key) && value !== '')
        .flatMap(
          ([key, value]) =>
            `${
              languageData[normalizedLanguage][
                key as keyof typeof languageData[typeof normalizedLanguage]
              ] ?? key
            }: ${value ?? ''}`,
        )
        .join('\n')
    : ''

  interWbSession.shareContent(`${title}:\n\n${message}`)

  interWbSession.requestAnalytics('DADOS_BANCARIOS_GA_FLUXO', {
    ref_figma: '65',
    flow: 'dados-bancarios',
    screen: 'dados-bancarios',
    ref_type: 'button',
    content_action: 'touch',
    action_id: 'share',
    share: title ?? '',
  })
}
